import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const DrugDetailesTab = ({ drugName, strength, drugUnit, form }) => {
  return (
    <Box>
      <Box sx={{ ml: '25px' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box>
            <Typography variant='body2' gutterBottom>
              Drug Name
            </Typography>
          </Box>
          <Box>
            <Typography gutterBottom>:</Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' sx={{ fontWeight: 600 }} gutterBottom>
              {drugName}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ ml: '25px' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box>
            <Typography variant='body2' gutterBottom>
              Strength
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' gutterBottom>
              :
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' sx={{ fontWeight: 600 }} gutterBottom>
              {strength}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ ml: '25px' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box>
            <Typography variant='body2' gutterBottom>
              Unit
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' gutterBottom>
              :
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' sx={{ fontWeight: 600 }} gutterBottom>
              {drugUnit || 'NA'}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ ml: '25px' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box>
            <Typography variant='body2' gutterBottom>
              Form
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' gutterBottom>
              :
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' sx={{ fontWeight: 600 }} gutterBottom>
              {form || 'NA'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DrugDetailesTab.propTypes = {
  drugName: PropTypes.string.isRequired,
  strength: PropTypes.string.isRequired,
  drugUnit: PropTypes.string,
  form: PropTypes.string,
};

DrugDetailesTab.defaultProps = {
  drugUnit: null,
  form: null,
};

export default DrugDetailesTab;
